import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'home' },
  },
  {
    path: '/',
    redirect: { name: 'login' },
  },
  {
    name: 'auth',
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      }
    ],
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'home' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'home',
        path: 'home',
        component: () => import('../pages/admin/dashboard/home.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'projects',
        path: 'projects',
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'payment-methods',
            path: 'payment-methods',
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
  {
    path: '/assetManagement',
    name:'assetManagement',
    component: AppLayout,
    children: [
      {
        name: 'assetTagList',
        path: '/assetManagement/assetTagList',
        component: () => import('../pages/assetManagement/assetTagList/index.vue'),
      },
      {
        name: 'assetList',
        path: '/assetManagement/assetList',
        component: () => import('../pages/assetManagement/assetList/index.vue'),
      },
      {
        name: 'assetEdit',
        path: '/assetManagement/assetEdit',
        component: () => import('../pages/assetManagement/assetList/edit.vue'),
      },
    ],
  },
  {
    path: '/themeManagement',
    name:'themeManagement',
    component: AppLayout,
    children: [
      {
        name: 'themeTagList',
        path: '/themeManagement/themeTagList',
        component: () => import('../pages/themeManagement/themeTagList/index.vue'),
      },
      {
        name: 'themeList',
        path: '/themeManagement/themeList',
        component: () => import('../pages/themeManagement/themeList/index.vue'),
      },
      {
        name: 'defaultThemEdit',
        path: '/themeManagement/defaultThemEdit',
        component: () => import('../pages/themeManagement/themeList/defaultThemEdit.vue'),
      },//默认主题
      {
        name: 'curveThemEdit',
        path: '/themeManagement/curveThemEdit',
        component: () => import('../pages/themeManagement/themeList/curveThemEdit.vue'),
      },
      {
        name: 'themeEdit',
        path: '/themeManagement/themeEdit',
        component: () => import('../pages/themeManagement/themeList/edit.vue'),
      },
      // groundEdit
      {
        name: 'groundEdit',
        path: '/themeManagement/groundEdit',
        component: () => import('../pages/themeManagement/themeList/groundEdit.vue'),
      },
      {
        name: 'themTest',
        path: '/themeManagement/polotno',
        component: () => import('../pages/themeManagement/themeList/test.vue'),
      },
      //主题模板列表
      {
        name: 'themeTemplateList',
        path: '/themeManagement/themeTemplateList',
        component: () => import('../pages/themeManagement/themeList/themeTemplateList.vue'),
      }
    ],
  },
  {
    path: '/accountManagement',
    name: 'accountManagement',
    component: AppLayout,
    children: [
      {
        name: 'accountList',
        path: '/accountManagement/accountList',
        component: () => import('../pages/accountManagement/accountList/index.vue'),
      },
      {
        name: 'menuList',
        path: '/accountManagement/menuList',
        component: () => import('../pages/accountManagement/menuList/index.vue'),
      },
      {
        name: 'twomenuList',
        path: '/accountManagement/twomenuList',
        component: () => import('../pages/accountManagement/menuList/twomenu.vue'),
      },
      {
        name: 'roleList',
        path: '/accountManagement/roleList',
        component: () => import('../pages/accountManagement/role/index.vue'),
      },
      {
        name: 'DistributionMenu',
        path: '/accountManagement/DistributionMenu',
        component: () => import('../pages/accountManagement/role/DistributionMenu.vue'),
      },
    ],
  },
  {
    name: 'faq',
    path: '/faq',
    component: () => import('../pages/faq/FaqPage.vue'),
  },
  {
    path: '/shopManagement',
    name: 'shopManagement',
    component: AppLayout,
    children: [
      {
        name: 'shopList',
        path: '/shopManagement/shopList',
        component: () => import('../pages/shopManagement/shopList/index.vue'),
      },
      {
        name: 'shopListEdit',
        path: '/shopManagement/shopListEdit',
        component: () => import('../pages/shopManagement/shopList/edit.vue'),
      },
       {
        name: 'shopListEditSlider',
        path: '/shopManagement/shopListEditSlider',
        component: () => import('../pages/shopManagement/shopList/editSlider.vue'),
      },
      {
        name: 'ShopAssociatedTerminals',
        path: '/shopManagement/ShopAssociatedTerminals',
        component: () => import('../pages/shopManagement/ShopAssociatedTerminals/index.vue'),
      },
      {
        name: 'ShopAssociatedAccount',
        path: '/shopManagement/ShopAssociatedAccount',
        component: () => import('../pages/shopManagement/ShopAssociatedAccount/index.vue'),
      },
    ],
  },
  {
    path: '/TerminalManagement',
    name: 'TerminalManagement',
    component: AppLayout,
    children: [
      {
        name: 'TerminalList',
        path: '/TerminalManagement/TerminalList',
        component: () => import('../pages/TerminalManagement/TerminalList/index.vue'),
      },
      {
        name: 'TerminalAssociatedTheme',
        path: '/TerminalManagement/TerminalAssociatedTheme',
        component: () => import('../pages/TerminalManagement/TerminalAssociatedTheme/index.vue'),
      },
    ],
  },
  {
    path: '/uploadTemplate',
    name: 'uploadTemplate',
    component: AppLayout,
    children:[
      {
        name: 'addTemplate',
        path: '/uploadTemplate/addTemplate',
        component: () => import('../pages/uploadTemplate/index.vue'),
      },
      {
        name: 'TemplateEdit',
        path: '/uploadTemplate/TemplateEdit',
        component: () => import('../pages/uploadTemplate/edit.vue'),
      },
      {
        name: 'tagList',
        path: '/uploadTemplate/tagList',
        component: () => import('../pages/uploadTemplate/tagList/index.vue'),
      },
    ]
  },
  {
    path: '/usageStatistics',
    name: 'usageStatistics',
    component: AppLayout,
    children:[
      {
        name: 'SessionData',
        path: '/usageStatistics/SessionData',
        component: () => import('../pages/UsageStatistics/SessionData.vue'),
      },
      {
        name: 'UsageSummary',
        path: '/usageStatistics/UsageSummary',
        component: () => import('../pages/UsageStatistics/UsageSummary.vue'),
      },
      {
        name: 'SingleThemeData',
        path: '/usageStatistics/SingleThemeData',
        component: () => import('../pages/UsageStatistics/SingleThemeData.vue'),
      },
       {
        name: 'ThemeSummary',
        path: '/usageStatistics/ThemeSummary',
        component: () => import('../pages/UsageStatistics/ThemeSummary.vue'),
      },
      {
        name: 'SingleCameraData',
        path: '/usageStatistics/SingleCameraData',
        component: () => import('../pages/UsageStatistics/SingleCameraData.vue'),
      },
      {
        name: 'CameraSummary',
        path: '/usageStatistics/CameraSummary',
        component: () => import('../pages/UsageStatistics/CameraSummary.vue'),
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
